import React, { useState, useRef, useEffect } from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";

const OfferCard = ({ lead_id }) => {
  const [params] = useSearchParams();

  const [showPopup, setShowPopup] = useState(false);
  const [counter, setCounter] = useState(15);
  const [isProcessing, setIsProcessing] = useState(false); // disables button
  const intervalRef = useRef(null);

  const offer = {
    lender_name: "MoneyView",
    credit_limit: "10 Lakhs",
    interest_rate: "14-36%",
    processing_fee: "2%",
    apr: "17-45%",
    penal_charges: "2% on overdue",
    tenure: 48,
    app_url: "#",
    kfs_doc: "https://lenders-kfs.s3.ap-south-1.amazonaws.com/moneyview.pdf",
    logo: "https://campaigns.digitmoney.in/image/Money-view.png",
    lead_id: lead_id || "No User ID found",
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    setUserClickData({
      event_name: "offer-pageview-scrubbed-old-moneyview",
      user_id: lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
  }, []);

  const handleClick = async () => {
    if (isProcessing) return; // prevent double click
    setIsProcessing(true);

    try {
      setUserClickData({
        event_name: `offer-apply-button-scrubbed-old-moneyview`,
        user_id: lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
      });

      await fetch("https://core-api.digitmoney.in/api/v1/lead/bulk-lead-push-by-leadId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks",
        },
        body: JSON.stringify({
          leads: [{ lead_id: lead_id }],
          lender_name: "MoneyView",
          lender_id: "662752eb65fdba1a48d6e464",
        }),
      });

      setShowPopup(true);
      setCounter(15);

      let timeLeft = 15;
      intervalRef.current = setInterval(() => {
        timeLeft -= 1;
        setCounter(timeLeft);

        if (timeLeft === 0) {
          clearInterval(intervalRef.current);
          callLenderApi();
        }
      }, 1000);
    } catch (err) {
      console.error("Error in first API call:", err);
      setIsProcessing(false);
      window.location.href = "https://digitmoney.in/no-offer";
    }
  };

  const callLenderApi = async () => {
    try {
      const response = await fetch(
        `https://loan-api.digitmoney.in/api/v1/lender_api_call/662752eb65fdba1a48d6e464/${lead_id}/lead-from-lenderApicall`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks",
          },
          body: JSON.stringify({
            pageSize: 1,
            pageNum: 1,
          }),
        }
      );

      const res = await response.json();
      const item = res?.data?.list?.[0];

      if (item?.is_qualified && item?.response?.app_url) {
        window.location.href = item.response.app_url;
      } else {
        window.location.href = "https://digitmoney.in/no-offer";
      }
    } catch (err) {
      console.error("Error in lender API call:", err);
      window.location.href = "https://digitmoney.in/no-offer";
    }
  };

  return (
    <div className="offer-card-section">
      <div className="offer-card expanded">
        <img src={offer.logo} className="lender-logo" alt="MoneyView" />

        <div className="offer-details">
          <hr className="offer-divider" />
          <div className="amount-row">
            <span className="amount-label1">Max Loan Amount:</span>
            <span className="amount-value">upto ₹{offer.credit_limit}</span>
          </div>
          <hr className="offer-divider" />
          <div className="emi-row">Tenure: {offer.tenure} Months</div>
          <hr className="offer-divider" />
          <div className="emi-row">Interest Rate: {offer.interest_rate}</div>
          <hr className="offer-divider" />
          <div className="w-full text-center pb-2">
            <span className="emi-row">Processing Fees: {offer.processing_fee}</span>
          </div>
          <hr className="offer-divider" />

          <div className="loan-extra-details mt-3 text-sm text-gray-700">
            <div className="flex justify-between mb-1 font-semibold">
              <span>APR:</span>
              <span>{offer.apr}</span>
            </div>
            <div className="flex justify-between mb-1 font-semibold">
              <span>Penal Charges:</span>
              <span>{offer.penal_charges}</span>
            </div>
            <div className="flex items-center justify-between mt-2 font-semibold">
              <span>View KFS:</span>
              <a
                href={offer.kfs_doc}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-green-700 hover:underline"
              >
                <FileText className="w-4 h-4 mr-1" />
                Document
              </a>
            </div>
          </div>

          <button
            className="get-offer-btn tracking-get-offer-btn-v5"
            onClick={handleClick}
            disabled={isProcessing} // disabled during countdown
          >
            {isProcessing ? `Processing... ${counter}s` : "Get Offer"}
            <img
              src="/assets/img/Get offer CTA icon.svg"
              alt="Arrow"
              className="cta-icon"
            />
          </button>
        </div>
      </div>

      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h2>Checking best offer...</h2>
            <p>Redirecting in {counter} seconds ⏳</p>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    textAlign: "center",
    width: "300px",
  },
};

export default OfferCard;